import { TextFieldComponent } from '@vivli/shared/components';
import { CSSProperties, useState } from 'react';
import { Color, Size, Styles } from '@vivli/shared/theme';
import { DTIAMRCommonConst, DTIFormFields } from '@vivli/shared/infrastructure/constants';
import { ButtonView, LoadingOverlayView } from '@vivli/shared/views';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

const containerStyle: CSSProperties = {
    padding: '40px',
    display: 'grid',
    gridTemplateRows: 'auto auto auto',
    rowGap: '10px',
    minWidth: '500px',
    position: 'relative',
};

const buttonContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: '10px',
};

const genericStyle: CSSProperties = {
    marginTop: Size.FIELD_SEPARATION,
    marginBottom: Size.FIELD_SEPARATION,
};

export const oneAcrossStyleNoBox: CSSProperties = {
    ...genericStyle,
    flex: '1 1 100%',
    maxWidth: '100%',
};

export const titleRowStyle: CSSProperties = {
    ...Styles.FORM_ROW,
    color: Color.VIVLI_DARK_BLUE,
};

interface AddCitationViewProps {
    onSave?: (citationDoi: string) => Subject<void>;
    onCancel?: () => void;
}

export const AddCitationView = ({ onSave, onCancel }: AddCitationViewProps) => {
    const [citationDoi, setCitationDoi] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const handleOnSave = () => {
        setIsLoading(true);
        onSave(citationDoi)
            .pipe(finalize(() => setIsLoading(false)))
            .subscribe();
    };

    return (
        <div style={containerStyle}>
            {isLoading && <LoadingOverlayView />}
            <div style={titleRowStyle}>Add a New Citation</div>
            <div style={oneAcrossStyleNoBox}>
                <TextFieldComponent
                    value={citationDoi}
                    style={oneAcrossStyleNoBox}
                    label={'Citation DOI (e.g. 10.xxxx/xxxxx)'}
                    dataId={DTIFormFields.FormStudyDoi}
                    onChange={(e) => setCitationDoi(e.target.value)}
                    focusOnLoad={true}
                />
            </div>
            <div style={buttonContainerStyle}>
                <ButtonView
                    style={buttonContainerStyle}
                    onClick={handleOnSave}
                    dataId={DTIAMRCommonConst.AddButton}
                    disabled={citationDoi.length === 0}
                >
                    Add
                </ButtonView>
                <ButtonView dataId={DTIAMRCommonConst.CancelButton} style={buttonContainerStyle} onClick={onCancel}>
                    Cancel
                </ButtonView>
            </div>
        </div>
    );
};
